/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Cps_Include_SpacesInputs */



/**
* | output |
* | --- |
* | "Include Spaces In CPS" |
*
* @param {Options_Metrics_Cps_Include_SpacesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_cps_include_spaces = /** @type {((inputs?: Options_Metrics_Cps_Include_SpacesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Cps_Include_SpacesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Include Spaces In CPS")
	if (locale === "de") return /** @type {LocalizedString} */ ("Include Spaces In CPS")
	if (locale === "it") return /** @type {LocalizedString} */ ("Include Spaces In CPS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Include Spaces In CPS")
	if (locale === "es") return /** @type {LocalizedString} */ ("Include Spaces In CPS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Include Spaces In CPS")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Include Spaces In CPS")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Include Spaces In CPS")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Include Spaces In CPS")
	return /** @type {LocalizedString} */ ("Include Spaces In CPS")
});